<template>
    <input v-model="inputValue" :id="id" :name="name"  :type="type"  v-bind:required="required" v-bind:value="inputValue"/>
</template>

<script>
export default {
    name: "YouryFormInput",
    data() {
        return {
            inputValue: null,}
            },
    mounted() {
        this.inputValue=this.value;
    },
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: false
        },
        id: {
            type: String,
            required: false
        },
        required: {
            type: Boolean,
            required: false
        },
        type: {
            validator: function (value) {
                // The value must match one of these strings
                return ['text','datetime','date','email','url','number'].indexOf(value) !== -1
            }
        }
    }
}
</script>

<style scoped>

</style>
